import { useState } from 'react';

// 半角文字のみ（ASCII印字可能文字 0x20-0x7E）
export const HALFWIDTH_PATTERN = /^[\x20-\x7E]*$/;

/**
 * 予約フォームの状態管理を行うカスタムフック
 */
export const useShareDeviceReservationForm = () => {
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');

  /**
   * メールアドレスが半角文字のみかチェック
   */
  const isEmailHalfWidth = () => {
    return HALFWIDTH_PATTERN.test(email);
  };

  /**
   * 全てのフィールドが入力されているかチェック
   */
  const isValid = () => {
    return (
      lastName.trim() !== '' &&
      firstName.trim() !== '' &&
      email.trim() !== '' &&
      isEmailHalfWidth()
    );
  };

  /**
   * フォームをリセット
   */
  const reset = () => {
    setLastName('');
    setFirstName('');
    setEmail('');
  };

  return {
    lastName,
    firstName,
    email,
    setLastName,
    setFirstName,
    setEmail,
    isValid,
    reset,
  };
};
